"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMortgageNews = initMortgageNews;
const firebase_1 = require("./firebase");
const firestore_1 = require("firebase/firestore");
const utils_1 = require("./utils");
const chevron_right_svg_1 = __importDefault(require("./assets/icons/chevron-right.svg"));
const FIRESTORE_COLLECTION = "mortgage_news";
const PAGE_SIZE = 9;
let lastDocument = null;
function initMortgageNews(container) {
    container.innerHTML = `
      <div class="mortgage-news">
        <div class="section-heading">Mortgage News</div>
        <div class="mortgage-news-list"></div>
      </div>
    `;
    const mortgageNews = container.querySelector(".mortgage-news");
    const sectionHeading = container.querySelector(".section-heading");
    const mortgageNewsList = container.querySelector(".mortgage-news-list");
    if (!mortgageNews || !sectionHeading || !mortgageNewsList)
        return;
    loadMortgageNews(container);
    let isLoading = false;
    let hasMoreData = true;
    const handleScroll = () => __awaiter(this, void 0, void 0, function* () {
        const rect = mortgageNewsList.getBoundingClientRect();
        const isNearBottom = rect.bottom <= window.innerHeight + 100;
        if (!isLoading && hasMoreData && isNearBottom) {
            isLoading = true;
            try {
                const hasMore = yield loadMortgageNews(container);
                hasMoreData = hasMore;
            }
            catch (error) {
                console.error("Error loading mortgage news:", error);
            }
            finally {
                isLoading = false;
            }
        }
        // const newsRect = mortgageNews.getBoundingClientRect();
        // const isInViewport = newsRect.top <= 0 && newsRect.bottom > 0;
        // if (isInViewport) {
        //     sectionHeading.classList.add("sticky");
        // } else {
        //     sectionHeading.classList.remove("sticky");
        // }
    });
    const throttle = (func, limit) => {
        let lastCall = 0;
        return (...args) => {
            const now = Date.now();
            if (now - lastCall >= limit) {
                lastCall = now;
                func(...args);
            }
        };
    };
    window.addEventListener("scroll", throttle(handleScroll, 200));
}
function loadMortgageNews(container) {
    return __awaiter(this, void 0, void 0, function* () {
        const mortgageNewsList = container.querySelector(".mortgage-news-list");
        if (!mortgageNewsList)
            return false;
        try {
            const db = yield (0, firebase_1.getFirestoreInstance)();
            let mortgageNewsQuery = (0, firestore_1.query)((0, firestore_1.collection)(db, FIRESTORE_COLLECTION), (0, firestore_1.orderBy)("date", "desc"), (0, firestore_1.limit)(PAGE_SIZE));
            if (lastDocument) {
                mortgageNewsQuery = (0, firestore_1.query)(mortgageNewsQuery, (0, firestore_1.startAfter)(lastDocument));
            }
            const querySnapshot = yield (0, firestore_1.getDocs)(mortgageNewsQuery);
            if (querySnapshot.empty) {
                console.log("No more mortgage news to load");
                return false;
            }
            querySnapshot.forEach((doc) => {
                const mortgageNewsData = doc.data();
                console.log("mortgageNewsData - ", mortgageNewsData);
                const mortgageNewsElement = document.createElement("div");
                mortgageNewsElement.classList.add("mortgage-news-item");
                mortgageNewsElement.innerHTML = `
                <div class="thumbnail" style="background-image: url('${mortgageNewsData.img_link}');"></div>
                <div class="date">${(0, utils_1.formatDate)(mortgageNewsData.date)}</div>
                <div class="title">${mortgageNewsData.headline}</div>
                <a class="read-more-link" href="${mortgageNewsData.source}" target="_blank">
                    Read More
                    <div class="read-more-icon">
                        <img src="${chevron_right_svg_1.default}" alt="Read More" />
                    </div>
                </a>
            `;
                mortgageNewsList.appendChild(mortgageNewsElement);
            });
            lastDocument = querySnapshot.docs[querySnapshot.docs.length - 1];
            return true;
        }
        catch (error) {
            console.error("Error loading mortgage news:", error);
            return false;
        }
    });
}
